@if (Company && LocalizationInfo) {
  <div class="container-fluid">
    <div class="row sticky-top">
      <div class="col">
        <span
          ><button (click)="close()" class="btn-close pull-right"></button
        ></span>
      </div>
    </div>
    <div class="row row-padding-bottom">
      <div class="col">
        <label class="fs-28">{{ title }}</label>
      </div>
    </div>
    <div class="row row-padding-bottom">
      <div class="col">
        <label class="fs-16"
          >Please enter in all of the vendor details below.</label
        >
      </div>
    </div>
    <app-add-edit-proposal-request-vendor
      [ProposalRequestVendorFormArray]="ProposalRequestVendorFormArray"
      [LocalizationInfo]="LocalizationInfo"
      [country]="country"
    ></app-add-edit-proposal-request-vendor>
    <div class="row row-padding">
      <div class="col"></div>
      <div class="col-3">
        <button class="btn btn-danger h-100" (click)="close()">Cancel</button>
      </div>
      <div class="col-3">
        <button class="btn btn-primary h-100" (click)="save()">Save</button>
      </div>
    </div>
  </div>
}
